import { Fragment } from 'react';
import { ChevronRight } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { MENU_SIDEBAR } from '@/config/menu.config';
import { cn } from '@/lib/utils';
import { useMenu } from '@/hooks/use-menu';
import { Container } from '@/components/common/container';

export function ToolbarHeading({ title = '' }) {
  const { pathname } = useLocation();
  const { getCurrentItem, getBreadcrumb, isActive } = useMenu(pathname);
  const item = getCurrentItem(MENU_SIDEBAR);
  const items = getBreadcrumb(MENU_SIDEBAR);

  return (
    <div className="flex items-center flex-wrap gap-1 lg:gap-5">
      <h1 className="font-medium text-lg text-mono">{title || item?.title}</h1>
      {items.length > 0 && (
        <div className="flex [.header_&]:below-lg:hidden items-center gap-1.25 text-xs lg:text-sm font-medium mb-2.5 lg:mb-0">
          <div className="breadcrumb flex items-center gap-1">
            {items.map((breadcrumbItem, index) => {
              const isLast = index === items.length - 1;
              const active = breadcrumbItem.path ? isActive(breadcrumbItem.path) : false;

              return (
                <Fragment key={index}>
                  {breadcrumbItem.path ? (
                    <Link
                      to={breadcrumbItem.path}
                      className={cn(
                        'flex items-center gap-1',
                        active
                          ? 'text-mono'
                          : 'text-muted-foreground hover:text-primary',
                      )}
                    >
                      {breadcrumbItem.title}
                    </Link>
                  ) : (
                    <span
                      className={cn(isLast ? 'text-mono' : 'text-muted-foreground')}
                    >
                      {breadcrumbItem.title}
                    </span>
                  )}
                  {!isLast && (
                    <ChevronRight className="size-3.5 muted-foreground" />
                  )}
                </Fragment>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export function ToolbarActions({ children }) {
  return <div className="flex items-center gap-2.5">{children}</div>;
}

function Toolbar({ children }) {
  return (
    <div className="mb-5 lg:mb-10">
      <Container className="flex items-center justify-between flex-wrap gap-5">
        {children}
      </Container>
    </div>
  );
}

export { Toolbar };

